import { Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";

import AnimatedCol from "../../../../../components/AnimatedCol";
import NumberOfTests from "./NumberOfTests";
import TestLoad from "./TestLoad";

import {
  selectNumberOfTestsForTypeExpert,
  selectTestLoadForTypeExpert,
  setNumberOfTestsForTypeExpert,
  setTestLoadForTypeExpert,
} from "../../../../../store/slices/lvTextSlice";

export default function PositionTestLoadsForSpecificationByGeotechnicalExperts() {
  const numberOfTests = useSelector(selectNumberOfTestsForTypeExpert);
  const testLoad = useSelector(selectTestLoadForTypeExpert);

  const dispatch = useDispatch();
  const dispatchSetNumberOfTests = (value) => dispatch(setNumberOfTestsForTypeExpert(value));
  const dispatchSetTestLoad = (value) => dispatch(setTestLoadForTypeExpert(value));

  return (
    <div className="mt-5">
      <Row>
        <AnimatedCol>
          <NumberOfTests value={numberOfTests} set={dispatchSetNumberOfTests} />
        </AnimatedCol>
      </Row>
      <Row>
        <AnimatedCol>
          <TestLoad value={testLoad} set={dispatchSetTestLoad} />
        </AnimatedCol>
      </Row>
    </div>
  );
}
